import { fetchResponse } from './serviceRequest';
import * as FPT from '../utility/fpt';

let extendSessionCalledAt = Date.now();

export function fireEvent(eventName) {
    const event = document.createEvent('Event');
    event.initEvent(eventName, true, true);
    document.dispatchEvent(event);
}

export const addActivityListeners = (listenerFunction) => {
    document.addEventListener('mousemove', listenerFunction, {
        once: true,
        capture: true,
        passive: true,
    });
    document.addEventListener('touchstart', listenerFunction, {
        once: true,
        capture: true,
        passive: true,
    });
    document.addEventListener('keydown', listenerFunction, {
        once: true,
        capture: true,
        passive: true,
    });
};

export const removeActivityListeners = (listenerFunction) => {
    document.removeEventListener('mousemove', listenerFunction, {
        once: true,
        capture: true,
        passive: true,
    });
    document.removeEventListener('touchstart', listenerFunction, {
        once: true,
        capture: true,
        passive: true,
    });
    document.removeEventListener('keydown', listenerFunction, {
        once: true,
        capture: true,
        passive: true,
    });
};

export const extendSessionAPI = async () => {
    // This function is called when the user click Extend Session and when the modal closes
    // Since the modal is closed after extending the session we need the logic below to prevent
    // duplicated extendSession call
    const seconds = (Date.now() - extendSessionCalledAt) / 1000;
    if (seconds < 10) return;

    extendSessionCalledAt = Date.now();
    await fetchResponse('/givingfund/extendSession', 'GET');
}